window.onload = () => {
	console.log('fight!');

	document.documentElement.classList.remove('no-js');
	document.documentElement.classList.add('js');


	registerScrollers();
	checkCookieNotice();

	[].forEach.call(document.querySelectorAll('a[href^="#"]'), x => {
		x.addEventListener('click', e => {
			e.preventDefault();

			let target = document.querySelector(e.currentTarget.getAttribute('href'))

			if(!target) return;


			window.scroll({ 
				top: target.offsetTop,
				behavior: 'smooth' 
			});
		})
	})

	const clickers = document.querySelectorAll('.clicker');

	if(clickers) {
		[].forEach.call(clickers, x => {
			x.addEventListener('click', e => {
				e.currentTarget.classList.toggle('clicked');
			})
		});
	}
}

const registerScrollers = () => {
	document.body.classList.remove('no-parallax');

	const animators = {
		header: basicScroll.create({
			elem: document.querySelector('.page'),
			from: 'top-top',
			to: 'bottom-bottom',
			direct: true,
			props: {
			  '--parallax': {
			    from: '0',
			    to: '200'
			  }
			}
		})
	};

	Object.values(animators).forEach(x => x.start());
}



const getCookie = cname => {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

const setCookie = (cname, cvalue) => {
  var d = new Date();
  d.setTime(d.getTime() + (30*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

const checkCookieNotice = () => {
  let cookiesAccepted = parseInt(getCookie("accept-cookies")) || false;

	setTimeout(() => {
		document.body.classList.remove('no-cookie-notice');
  		document.body.classList.toggle('cookies-accepted', cookiesAccepted != "");
	}, 3000);

	setTimeout(() => {
		document.body.classList.add('no-cookie-notice');
	}, 15000)

  var cookieButton = document.querySelector('.cookie-notice button');

  if(!cookiesAccepted && cookieButton != undefined) {
    cookieButton.onclick = () => {
      document.body.classList.add('cookies-accepted');
      setCookie("accept-cookies", "1");
    };
  }
};
